import { render, staticRenderFns } from "./AddDailyExpense.vue?vue&type=template&id=71796894&"
import script from "./AddDailyExpense.vue?vue&type=script&lang=js&"
export * from "./AddDailyExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports